import React, { memo } from 'react'
import { Autocomplete } from 'components/forms/autocomplete/DPLAutocomplete'
import SuggestLocation, { ILocationSuggestion } from 'transfix-ui/components/SuggestLocation'
import {
  IGeographicCriteria,
  ISpotBiddingRule,
  GEOGRAPHIC_CRITERIA_TYPE,
} from 'apps/spot-quote-control-panel/types/spotBiddingConfig'
import { capitalize } from 'utils/capitalize'

interface IGeoValueProps {
  value?: RecursivePartial<IGeographicCriteria>
  onChange(change: RecursivePartial<ISpotBiddingRule>): void
  error?: string
}

export const GeoValue = memo<IGeoValueProps>(({ error, onChange, value: geographicCriteria }) => {
  const { criteriaType, value } = geographicCriteria || {}
  const setLocation = (location: string) => {
    onChange({
      geographicCriteria: {
        ...geographicCriteria,
        value: location,
      },
    })
  }

  const cityStateHandler = (location: ILocationSuggestion) => {
    const { city, state } = location
    const cityState = city && state ? `${city}, ${state}` : ''
    setLocation(cityState)
  }

  const stateHandler = ({ state }: ILocationSuggestion) => {
    setLocation(state || '')
  }

  const datMarketHandler = ({
    fullSelection,
  }: {
    value: number
    fullSelection?: { name: string }
  }) => {
    setLocation(fullSelection?.name || '')
  }

  const label = criteriaType ? capitalize(criteriaType.split('_').join(' ')) : undefined
  const placeValue = (() => {
    if (!value) return undefined
    if (criteriaType === GEOGRAPHIC_CRITERIA_TYPE.cityState) {
      const [city, state] = value.split(', ')
      return { city, state }
    }
    if (criteriaType === GEOGRAPHIC_CRITERIA_TYPE.state) {
      return { state: value }
    }
    if (criteriaType === GEOGRAPHIC_CRITERIA_TYPE.datMarket) {
      return { name: value }
    }

    return undefined
  })()

  return (
    <>
      {criteriaType && (
        <div className='col-md-6 col-xs-4'>
          {criteriaType === GEOGRAPHIC_CRITERIA_TYPE.cityState && (
            <SuggestLocation
              label={label}
              placeholder={`Enter ${label}`}
              countries={['US']}
              resultTypes={['City']}
              id='modal-geo-city-state'
              value={placeValue}
              dataTest='modal-geo-city-state'
              onChange={cityStateHandler}
              large
              errorMessage={error}
              invalid={!!error}
            />
          )}
          {criteriaType === GEOGRAPHIC_CRITERIA_TYPE.state && (
            <SuggestLocation
              id='modal-geo-state'
              label={label}
              placeholder='Enter state name'
              countries={['US']}
              resultTypes={['State']}
              value={{ state: placeValue?.state }}
              onChange={stateHandler}
              large
              errorMessage={error}
              invalid={!!error}
              dataTest='modal-geo-state'
            />
          )}
          {criteriaType === GEOGRAPHIC_CRITERIA_TYPE.datMarket && (
            <Autocomplete
              id='modal-geo-dat-market'
              label={label}
              value={placeValue?.name}
              type='dat_market'
              onChange={datMarketHandler}
              large
              validationMessage={error}
              dataTest='modal-geo-dat-market'
            />
          )}
        </div>
      )}
    </>
  )
})
